import { PostRequest } from "../../utils/ApiServices";

export const SendSubscription = async (email) => {
  return await PostRequest("subscriptions", {
    email: email,
  });
};
